export default __webpack_public_path__ + "static/media/gallery_02.9b74bb6c.jpg";